// One rule set for the Task Management stat cards AND the list, so they always agree.
// Days are Eastern calendar days (see dueDates.js), the same rule Today's Tasks uses for OVERDUE.
import { dayKey, todayET } from './dueDates';

export const isOpenTask = (t) => !!t && t.status !== 'completed' && t.status !== 'na';
const addDays = (iso, n) => { const [y, m, d] = iso.split('-').map(Number); const x = new Date(Date.UTC(y, m - 1, d + n)); return x.toISOString().slice(0, 10); };
export const isOverdueTask = (t, now = new Date()) => { const k = dayKey(t?.dueDate); return isOpenTask(t) && !!k && k < todayET(now); };
export const isDueTodayTask = (t, now = new Date()) => isOpenTask(t) && dayKey(t?.dueDate) === todayET(now);
export const isUpcomingTask = (t, now = new Date(), days = 7) => {
  const k = dayKey(t?.dueDate); const today = todayET(now);
  return isOpenTask(t) && !!k && k > today && k <= addDays(today, days);
};
// "Next 7 days" view: anything open that is overdue, due within 7 days, or has no due date.
export const inNext7View = (t, now = new Date()) => { const k = dayKey(t?.dueDate); return isOpenTask(t) && (!k || k <= addDays(todayET(now), 7)); };

// Three non-overlapping buckets: before today, today, tomorrow through 7 days out (Eastern days).
export const taskCounts = (tasks, now = new Date()) => {
  const open = (tasks || []).filter(isOpenTask);
  return {
    overdue: open.filter((t) => isOverdueTask(t, now)).length,
    dueToday: open.filter((t) => isDueTodayTask(t, now)).length,
    upcoming: open.filter((t) => isUpcomingTask(t, now)).length,
  };
};
